import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFactory } from "../types/IFactory";

export type IFactoryDeleteMutationParameters = {
    factory: RelationalValue<IFactory>;
};

export type IFactoryDeleteMutationResult = void;

export const factoryDeleteMutation: IApiMutationFunction<IFactoryDeleteMutationParameters> = ({ factory }) => {
    return {
        method: "DELETE",
        url: `/factories/${mapRelationalValue(factory)}`,
    };
};

export const useFactoryDeleteMutation = createApiMutationHook<
    IFactoryDeleteMutationParameters,
    IFactoryDeleteMutationResult
>(factoryDeleteMutation);
